import api from '../../../App/socket';

export const addGroup = params => (
    api.send({
        api: 'db',
        model: 'User_group',
        action: 'Create',
        options: {
            create: {
                abbr: params.abbr.toUpperCase(),
                name: params.name,
                description: params.description,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/requests/add_group_request.js